/**
 * Site configuration.
 *
 * Everything here is language-independent: URLs, identifiers, ordering. All
 * prose lives in `public/i18n/{lang}.json` and is merged in by ContentService.
 */

import { environment } from '../../../environments/environment';

/**
 * Onboarding lives in a separate application per product and moves between
 * environments, so the addresses come from `environments/`, not from here.
 */
export const ONBOARDING = environment.onboarding;

/** Where an existing customer signs in. Per-environment, same as ONBOARDING. */
export const APP_URLS = environment.apps;

export const COMPANY = {
  product: 'Avyna',
  legalName: 'AlgoCreed',
  parent: 'AlgoCreed',
  domain: 'avyna.io',
  contactEmail: 'contact@avyna.io',
} as const;

/** The Avyna Agent is part of Core, so it is deliberately absent from `PRODUCT_CONFIG`. */
export const AGENT_ROUTE = '/core/agent';

/**
 * Catalog's demo, booked on Microsoft Bookings: a page of AlgoCreed's own tenant, the same in
 * every environment. It is Catalog's alone, so inside Core's area the bar's demo is
 * `CORE_DEMO_HREF` instead; see `ContentService.headerActions`.
 */
export const DEMO_BOOKING_URL =
  'https://bookings.cloud.microsoft/book/AvynaCatalog1@algocreed.com/?ismsaljsauthenabled';

/** The bar's demo inside Core's area, the contact form preset to a walkthrough. */
export const CORE_DEMO_HREF = '/contact?intent=walkthrough';

/** The bar's start inside Core's area, where there is no trial to start. */
export const HEADER_PILOT_HREF = '/contact?product=core';

/** Company and sign-in columns; order matches `site.footer.columns` in the translation files. */
export const FOOTER_LINKS: readonly (readonly { href: string; external?: boolean }[])[] = [
  [{ href: '/#company' }, { href: '/contact' }, { href: DEMO_BOOKING_URL, external: true }],
  [
    { href: APP_URLS.catalog, external: true },
    // { href: APP_URLS.core, external: true },
    { href: ONBOARDING.catalog, external: true },
  ],
];
